// CustomerServiceScriptLoader.js;
'use strict';
import { connect } from 'react-redux';

import { INTERCOM_ID, ZENDESK_KEY } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import setIntercomData from '../action/setIntercomData.js';
import CustomerServiceScriptLoader from '../component/CustomerServiceScriptLoader.jsx';

const mapStateToProps = state => {
  return {
    intercomId: getRemoteConfigData(state, INTERCOM_ID),
    zendeskKey: getRemoteConfigData(state, ZENDESK_KEY),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    displayIntercom: () =>
      dispatch(setIntercomData({ canDisplayIntercom: true })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerServiceScriptLoader);
